<div style="background: #F5F5F5; padding: 16px;">
  <div class="row page-title-bar" style="margin-bottom: 16px;">
    <div class="medium-12 title">Tax Strategies</div>
  </div>
  <div class="row" style="background: #FFFFFF;">
    <div class="column large-4 medium-4 small-4" style="font-size: 14px !important;margin: 15px 0 5px 0;">
      <div style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 5px 14px;">
        <input (keyup)="filterData()" [(ngModel)]="searchKey" placeholder="Search strategy"
               style="border-bottom: none !important;margin-bottom: 0;" type="text"/>
      </div>
    </div>
    <div class="column large-8 medium-8 small-8" style="font-size: 14px !important;margin: 15px 0 5px 0;">
      <div class="float-right" style="margin-right: 10px;">
          <span class="float-right text-left tasks-filter">
            <app-strategy-tags-search></app-strategy-tags-search>
          </span>
      </div>
      <!-- <div (click)="showAcceptAllUpdatesReveal()" *ngIf="org !== 'trialtaxplaniq' && showAllAccept"
           class="compose-post float-right" style="margin-top: 5px;margin-left: 5px;">
        <span style="padding-left: 20px">Accept All Updates</span>
      </div> -->
      <div (click)="addNewTaxStrategy()" class="float-right pointer"
           style="margin: 10px 10px;color: #1570EF;display: inline-flex;">
        <i class="material-icons">add</i><span style="position: relative;top: 2px;">Create new Tax Strategy</span>
      </div>
      <div *ngIf="isInternalUser" (click)="goToFormulaTestCases()" class="float-right pointer"
           style="margin: 10px 10px;color: #1570EF;display: inline-flex;">
        <i class="material-icons">functions</i><span style="position: relative;top: 2px;">Formula Test Cases</span>
      </div>
    </div>
  </div>
  <div *ngIf="searchFilters && searchFilters.length > 0" class="row" style="background: #FFFFFF;">
    <div class="column medium-12" style="font-size: 12px !important;color: #333333;margin: 15px 0;">Applied Filters:
      <span *ngFor="let search of searchFilters | slice:0:3; let i = index"
            style="padding: 5px;background: #EFF8FF;border-radius: 6px;color: #175CD3;font-size: 12px;margin:0 15px;">{{search.displayName}}:{{search.value}}
        <span class="pointer">
        <i (click)="removeSearchItem(search, i)" class="icon ion-close-round tag-remove"
           style="color: #2E90FA;font-size: 12px;"></i>
     </span>
   </span>
    </div>
  </div>
  <div class="row preferences client-todos tax-planning-clients" style="background: #FFFFFF;padding-left: 0px;">
    <div class="column large-12 medium-12 small-12 foo-container icons-table" style="padding: 0;">
      <div class="tab-container books-tab-container">
        <div class="collapse tab-content clients-data">
          <div class="indy-tables badge-tables tooltip-overflow">
            <app-tracker-paginated-table (onRowAction)="handleAction($event)" (onScroll)="handleScroll($event)"
                                         (onSort)="sortByColumn($event)" *ngIf="hasTaxStrategyList"
                                         [setObj]="taxStrategyTableData"></app-tracker-paginated-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="reveal['rules']">
  <div [ngClass]="{'tpiq-reveal': reveal['rules']}" class="reveal-overlay"></div>
  <div [ngClass]="{'tpiq-reveal': reveal['rules']}" class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 70%; max-width: 980px;">
    <div style="height: 50px; padding: 15px; color: #333333; display: flex; align-items: center; justify-content: space-between;">
      <span class="float-left">Rules</span>
      <span class="float-right pointer" (click)="hideRulesPopup()">X</span>
    </div>
    <div style="padding: 0 15px;"><hr style="margin: 0;"/></div>
    <div class="body" style="padding: 15px; max-height: 80vh; overflow: auto;">
        <div class="row">
          <div class="medium-6 columns">
            <label class="strategy-view-label">Formula</label>
            <ng-container *ngIf="!isRulesEditable; else formulaEdit">
              <div class="strategy-view-content">{{ruleStrategy?.rules?.formula || '—'}}</div>
            </ng-container>
            <ng-template #formulaEdit>
              <textarea rows="3" class="strategy-view-content" [(ngModel)]="ruleStrategy.rules.formula" placeholder="Enter formula"></textarea>
            </ng-template>
          </div>
          <div class="medium-6 columns">
            <label class="strategy-view-label">Plan Amount Formula</label>
            <ng-container *ngIf="!isRulesEditable; else planAmountEdit">
              <div class="strategy-view-content">{{ruleStrategy?.rules?.planAmountFormula || '—'}}</div>
            </ng-container>
            <ng-template #planAmountEdit>
              <textarea rows="3" class="strategy-view-content" [(ngModel)]="ruleStrategy.rules.planAmountFormula" placeholder="Enter plan amount formula"></textarea>
            </ng-template>
          </div>
          <div class="medium-12 columns margin-top-20">
            <label class="strategy-view-label">Why Description</label>
            <ng-container *ngIf="!isRulesEditable; else whyEdit">
              <div class="strategy-view-content" [innerHTML]="ruleStrategy?.rules?.whyDescription || '—'"></div>
            </ng-container>
            <ng-template #whyEdit>
              <textarea rows="3" class="strategy-view-content" [(ngModel)]="ruleStrategy.rules.whyDescription" placeholder="Enter why description"></textarea>
            </ng-template>
          </div>
          <div class="medium-12 columns margin-top-20">
            <label class="strategy-view-label">Field Description</label>
            <ng-container *ngIf="!isRulesEditable; else fieldEdit">
              <div class="strategy-view-content" [innerHTML]="ruleStrategy?.rules?.fieldDescription || '—'"></div>
            </ng-container>
            <ng-template #fieldEdit>
              <textarea rows="3" class="strategy-view-content" [(ngModel)]="ruleStrategy.rules.fieldDescription" placeholder="Enter field description"></textarea>
            </ng-template>
          </div>

          <div class="medium-12 columns margin-top-20">
            <div class="discovery-ai-section">
              <div class="discovery-ai-section-title">Discovery AI Fields</div>
              <div class="row">
                <div class="medium-6 columns">
                  <label class="strategy-view-label">AI Q JSON Field</label>
                  <ng-container *ngIf="!isRulesEditable; else aiQJsonFieldEdit">
                    <div class="strategy-view-content discovery-ai-value">{{ruleStrategy?.rules?.aiQJsonField || '—'}}</div>
                  </ng-container>
                  <ng-template #aiQJsonFieldEdit>
                    <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="ruleStrategy.rules.aiQJsonField" placeholder="Enter AI Q JSON field"></textarea>
                  </ng-template>
                </div>

                <div class="medium-6 columns">
                  <label class="strategy-view-label">AI Q Category
                    <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
                      <i class="icon ion-ios-information-outline info-icon" style="font-size: 15px; color: #475467;"></i>
                      <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 260px !important; line-height: 1.35;">
                        Category: Updating this will update the Category of the Strategy.
                      </span>
                    </span>
                  </label>
                  <ng-container *ngIf="!isRulesEditable; else aiQCategoryEdit">
                    <div class="strategy-view-content discovery-ai-value">{{ruleStrategy?.rules?.aiQCategory || '—'}}</div>
                  </ng-container>
                  <ng-template #aiQCategoryEdit>
                    <select class="strategy-view-content discovery-ai-select" [(ngModel)]="ruleStrategy.rules.aiQCategory">
                      <option value="">Select category</option>
                      <option *ngFor="let category of stratagiesTypes" [value]="category.type">{{category.type}}</option>
                    </select>
                  </ng-template>
                </div>

                <div class="medium-6 columns margin-top-20">
                  <label class="strategy-view-label">AI Q Gate</label>
                  <ng-container *ngIf="!isRulesEditable; else aiQGateEdit">
                    <div class="strategy-view-content discovery-ai-value">{{ruleStrategy?.rules?.aiQGate || '—'}}</div>
                  </ng-container>
                  <ng-template #aiQGateEdit>
                    <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="ruleStrategy.rules.aiQGate" placeholder="Enter AI Q gate"></textarea>
                  </ng-template>
                </div>

                <div class="medium-6 columns margin-top-20">
                  <label class="strategy-view-label">AI Q Gate Title</label>
                  <ng-container *ngIf="!isRulesEditable; else aiQGateTitleEdit">
                    <div class="strategy-view-content discovery-ai-value">{{ruleStrategy?.rules?.aiQGateTitle || '—'}}</div>
                  </ng-container>
                  <ng-template #aiQGateTitleEdit>
                    <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="ruleStrategy.rules.aiQGateTitle" placeholder="Enter AI Q gate title"></textarea>
                  </ng-template>
                </div>

                <div class="medium-6 columns margin-top-20">
                  <label class="strategy-view-label">AI Q Discovery Question</label>
                  <ng-container *ngIf="!isRulesEditable; else aiQDiscoveryQuestionEdit">
                    <div class="strategy-view-content discovery-ai-value">{{ruleStrategy?.rules?.aiQDiscoveryQuestion || '—'}}</div>
                  </ng-container>
                  <ng-template #aiQDiscoveryQuestionEdit>
                    <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="ruleStrategy.rules.aiQDiscoveryQuestion" placeholder="Enter discovery question"></textarea>
                  </ng-template>
                </div>

                <div class="medium-6 columns margin-top-20">
                  <label class="strategy-view-label">AI Q Min Risk
                    <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
                      <i class="icon ion-ios-information-outline info-icon" style="font-size: 15px; color: #475467;"></i>
                      <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 320px !important; line-height: 1.35;">
                        Risk: Updating this will update the Risk of the Strategy, not the Discovery Fields.
                      </span>
                    </span>
                  </label>
                  <ng-container *ngIf="!isRulesEditable; else aiQMinRiskEdit">
                    <div class="strategy-view-content discovery-ai-value">{{ruleStrategy?.rules?.aiQMinRisk || '—'}}</div>
                  </ng-container>
                  <ng-template #aiQMinRiskEdit>
                    <select class="strategy-view-content discovery-ai-select" [(ngModel)]="ruleStrategy.rules.aiQMinRisk">
                      <option value="">Select risk</option>
                      <option *ngFor="let risk of aiQRiskLevels" [value]="risk.value">{{risk.key}}</option>
                    </select>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row edit-actions-row" style="margin-top: 20px;">
          <div class="medium-12 columns text-right">
            <ng-container *ngIf="!isRulesEditable; else editButtons">
              <button class="button small edit-action-btn" (click)="enableRulesEdit()" [disabled]="isRulesSaving">Edit</button>
            </ng-container>
            <ng-template #editButtons>
              <button class="button small edit-action-btn" (click)="saveRules()" [disabled]="isRulesSaving">Save</button>
              <button class="button small cancel-button edit-action-btn" (click)="cancelRulesEdit()" [disabled]="isRulesSaving">Cancel</button>
            </ng-template>
          </div>
        </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['addNewStrategy']">
  <div [ngClass]="{'tpiq-reveal': reveal['addNewStrategy']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['addNewStrategy']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 75%;">
    <div style="padding: 15px; color: #333333;">
      <span (click)="hideReveal('addNewStrategy')" class="float-right pointer">X</span>
      <span class="float-right pointer">
        <i (click)="minimizeReveal('addNewStrategy')" class="material-icons" style="font-size: 1.7em;margin-right: 6px">keyboard_arrow_down</i>
      </span>
    </div>
    <div class="body" style="padding: 15px;height: 90vh;">
      <app-create-or-update-strategy (onCancelCreationOfStrategy)="hideReveal('addNewStrategy')" (onCreateOrUpdateStrategy)="refreshStrategiesList()"
                                     [editMode]="editMode"
                                     [taxStrategyId]="currentStrategyId"></app-create-or-update-strategy>
    </div>
  </div>
</div>

<div *ngIf="reveal['hasUpdates']">
  <div [ngClass]="{'tpiq-reveal': reveal['hasUpdates']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['hasUpdates']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 100%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Updates</span>
      <span (click)="hideReveal('hasUpdates')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <span>AdvisorIQ published changes to this strategy. Would you like to accept them?</span>
        </div>
      </div>
      <div class="row-padding-reveal text-center">
        <button (click)="acceptOrDenyUpdates('accept')" class="button small">ACCEPT</button>
        <button (click)="acceptOrDenyUpdates('deny')" class="button small" style="background: #f1645a !important;">
          DENY
        </button>
      </div>
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <app-tax-strategy [parentStrategyId]="parentStrategyId"></app-tax-strategy>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['acceptAll']">
  <div [ngClass]="{'tpiq-reveal': reveal['acceptAll']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['acceptAll']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Updates</span>
      <span (click)="hideReveal('acceptAll')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <span>You are about to accept all the strategy updates provided by TaxPlanIQ. This will override any information you have edited in the strategies except for the firm customization tab. Would you like to continue?</span>
        </div>
      </div>
      <div class="row-padding-reveal text-right">
        <button (click)="acceptAllStrategiesUpdates()" class="button small">YES</button>
        <button (click)="hideReveal('acceptAll')" class="button small" style="background: #f1645a !important;">NO
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['deletedByParent']">
  <div [ngClass]="{'tpiq-reveal': reveal['deletedByParent']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['deletedByParent']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Delete Confirmation</span>
      <span (click)="hideReveal('deletedByParent')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <span>AdvisorIQ deleted this strategy. Do you also want to delete this strategy?</span>
        </div>
      </div>
      <div class="row-padding-reveal text-right">
        <button (click)="acceptOrDenyDeletedByParent('delete')" class="button small">YES, delete for me</button>
        <button (click)="acceptOrDenyDeletedByParent('ignore')" class="button small"
                style="background: #f1645a !important;">NO
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['deleteChildren']">
  <div [ngClass]="{'tpiq-reveal': reveal['deleteChildren']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['deleteChildren']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 35%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Confirmation</span>
      <span (click)="hideReveal('deleteChildren')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <span>Do you wish to delete this strategy to all instances?</span>
        </div>
      </div>
      <div class="row-padding-reveal text-right">
        <button (click)="deleteTaxStrategy('yes')" class="button small">YES</button>
        <button (click)="deleteTaxStrategy('no')" class="button small" style="background: #f1645a !important;">NO
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isMinimized" class="row min-wall-add-task minimized-add-strategy">
  <div class="small-6 medium-8 columns min-title">{{editMode ? 'Update Strategy!' : 'Add Strategy!'}}</div>
  <div class="small-6 medium-4 columns" style="text-align: right">
    <span><i (click)="addNewTaxStrategy()" class="material-icons min-task">keyboard_arrow_up</i></span>
    <span><i (click)="hideReveal('addNewStrategy', true)" class="material-icons min-close">clear</i></span>
  </div>
</div>
